import { Component, h, Host } from "@stencil/core";

@Component({
    tag: "ux-iws-cookie-required",
    styleUrl: "cookie-required.scss",
    shadow: true,
})
export class CookieRequired {
    render() {
        return (
            <Host>
                <div>
                    <ux-icon name="circle-info" />
                    <div class="headline">
                        <slot name="headline"></slot>
                    </div>
                    <div class="text">
                        <slot></slot>
                    </div>
                </div>
            </Host>
        );
    }
}
